import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IpdComponent} from './ipd.component';
import {LayoutModule} from '../layout/layout.module';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AutoCompleteModule, DialogModule, MultiSelectModule} from 'primeng/primeng';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
import {routing} from './ipd.routing';
import {MstPatientService} from '../configuration/mst-patient/mst-patient.service';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {VacantBedModule} from './bed-management/under-maintenance/vacant-bed/vacant-bed.module';
import {TrnDischargelistModule} from './trn-dischargelist/trn-dischargelist.module';
import {DischargeModule} from './discharge/discharge.module';
import {DischargeSummaryModule} from './discharge-summary/discharge-summary.module';
import {DischargeSummaryNewModule} from './discharge-summary-new/discharge-summary-new.module';
import {PatientRegistrationService} from '../opd/patient-registration/patient-registration.service';
import { PatientEmrDashboardComponent } from './patient-emr-dashboard/patient-emr-dashboard.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    routing,
    DialogModule,
    SharedTranslationModule,
    AutoCompleteModule,
    BrowserAnimationsModule,
    MultiSelectModule,
    TrnDischargelistModule,
    LayoutModule,
    DischargeSummaryModule,
    VacantBedModule,
    DischargeModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
      DischargeSummaryNewModule

  ],
  declarations: [IpdComponent],
  providers: [MstPatientService, PatientRegistrationService]
})
export class IpdModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/ipd.module.ts